import { View } from 'foundations-components/components/View';
import { useCallback, useEffect, useRef } from 'react';
import HsocMerchCardGrid from 'pricing-pages-ui-hsoc/components/HsocMerchCardGrid';
import { HsocV2PageHero } from 'pricing-pages-ui-hsoc/components/HsocV2PageHero';
import { HsocV2Faqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/hsoc/HsocV2Faqs';
import { useHsocPublicPricing } from './useHsocPublicPricing';
import { HUBSPOT_ON_CREDITS_PAGE } from '../../components/error-boundary/ErrorBoundaryNames';
import { PublicPageWrapper } from '../../components/PublicPageWrapper';
import { useCurrency } from '../../context/CurrencyContext';
import { HSOC_V2_SCREEN, TRACKING_SOURCES, trackClickedLink, trackFaqInteraction, trackHsocV2PageView, trackSectionViewed, trackTermSelectorInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function HsocPublicPageContent() {
  const {
    displayedCurrencyCode
  } = useCurrency();
  const {
    loading,
    error,
    cards,
    showTermToggle,
    onTermChange: setTerm
  } = useHsocPublicPricing(displayedCurrencyCode);
  const handleTermChange = useCallback(term => {
    setTerm(term);
    trackTermSelectorInteraction({
      action: 'click',
      term,
      trackingSource: TRACKING_SOURCES.MERCH_CARD,
      screen: HSOC_V2_SCREEN
    });
  }, [setTerm]);
  if (error) throw error;
  const showCards = !loading && cards.length > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HsocV2PageHero, {}), showCards && /*#__PURE__*/_jsx(View, {
      padding: "800",
      children: /*#__PURE__*/_jsx(HsocMerchCardGrid, {
        cards: cards,
        showTermToggle: showTermToggle,
        onTermChange: handleTermChange
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "section",
      padding: "800",
      marginBlockStart: "1400",
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(HsocV2Faqs, {
        onLinkClick: props => trackClickedLink(Object.assign({}, props, {
          trackingSource: TRACKING_SOURCES.FAQ,
          screen: HSOC_V2_SCREEN
        })),
        onFaqInteraction: trackFaqInteraction,
        onSectionViewed: () => trackSectionViewed({
          name: TRACKING_SOURCES.FAQ,
          action: 'scrolled in view'
        })
      })
    })]
  });
}
export default function PublicHsocPricingPage() {
  const hasTrackedPageViewRef = useRef(false);
  useEffect(() => {
    if (!hasTrackedPageViewRef.current) {
      hasTrackedPageViewRef.current = true;
      trackHsocV2PageView();
    }
  }, []);
  return /*#__PURE__*/_jsx(PublicPageWrapper, {
    errorBoundaryName: HUBSPOT_ON_CREDITS_PAGE,
    navMarkerName: "HSOC_V2_PAGE",
    metricsRoute: "hubspot-credits",
    chunkName: "public-hsoc-pricing-page",
    children: /*#__PURE__*/_jsx(HsocPublicPageContent, {})
  });
}